import { __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import KFab from '../../../../KButtons/KFab/index.js';

var PictureViewerAction = function PictureViewerAction(_a) {
    var title = _a.title, ariaLabel = _a.ariaLabel, onClick = _a.onClick, icon = _a.icon, sx = _a.sx, style = _a.style, className = _a.className, _b = _a.testId, testId = _b === void 0 ? "PictureViewerAction" : _b;
    return (React__default.createElement(KFab, { size: "small", className: clsx("PictureViewerAction", className), "data-testid": testId, style: style, onClick: onClick ? function () { return onClick(); } : undefined, title: title, "aria-label": ariaLabel, sx: __assign({ backgroundColor: function (theme) { return theme.palette.common.black; }, color: function (theme) { return theme.palette.common.white; }, opacity: "0", transition: "opacity 0.3s", "&:hover": {
                backgroundColor: function (theme) { return theme.palette.common.black; },
                cursor: "pointer",
                opacity: "1!important"
            }, "&:focus": {
                backgroundColor: function (theme) { return theme.palette.common.black; },
                cursor: "pointer",
                opacity: "1!important"
            }, "& .fas": {
                fontSize: "1.2rem"
            } }, (sx && sx)) }, icon));
};

export { PictureViewerAction as default };
//# sourceMappingURL=index.js.map
